import { render, staticRenderFns } from "./promise_text.vue?vue&type=template&id=3d00bb75"
import script from "./promise_text.vue?vue&type=script&lang=js"
export * from "./promise_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports